import React from 'react';
import { createPortal } from 'react-dom';
import PickerList from './PickerList';
import '../mobile.css';

// Full-screen picker rendered inline (not routed) so the onSelect callback
// stays in memory instead of needing to survive router-state serialization.
//
// Rendered via a portal to document.body rather than in place: every caller
// mounts this inside `.m-content`, which sets `-webkit-overflow-scrolling:
// touch` for momentum scrolling. On iOS Safari/WebKit that property makes
// the scroll container a new containing block for descendant `position:
// fixed` elements, so this modal's `inset: 0` would resolve against
// `.m-content`'s full scrollable area instead of the viewport - pushing the
// header/list out of alignment with what's actually on screen. A portal to
// body keeps it a true fixed overlay regardless of that ancestor.
const PickerModal = ({ title, options, selected, onSelect, onClose }) => createPortal(
  <div
    style={{
      position: 'fixed',
      inset: 0,
      background: '#fff',
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px',
        borderBottom: '1px solid #eee',
      }}
    >
      <span style={{ fontSize: '18px', fontWeight: 600, color: '#094268' }}>{title}</span>
      <button
        onClick={onClose}
        style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#094268' }}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
    <div style={{ flex: 1, overflowY: 'auto' }}>
      <PickerList
        options={options}
        selected={selected}
        onSelect={(value) => {
          onSelect(value);
          onClose();
        }}
      />
    </div>
  </div>,
  document.body
);

export default PickerModal;
